import styled from '@emotion/styled'
import { Navbar } from 'react-bootstrap'
import theme from '../../constants/theme'
import Info from '../../assets/svgs/info'

export const Page = styled('div')(() => ({
  backgroundColor: '#F4F7FB',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
}))

export const LoadingWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  background: '#F4F7FB',
}))

export const TopBar = styled(Navbar)(() => ({
  background: theme.white,
  height: '50px',
  boxShadow: `0px 6px 18px ${theme.boxShadow}`,
}))

export const Content = styled('div')(() => ({
  width: '100%',
  maxWidth: '640px',
  margin: '0 auto',
  padding: '24px 16px 40px',
}))

export const Card = styled('div')(() => ({
  background: theme.white,
  borderRadius: '14px',
  boxShadow: theme.boxShadow,
  padding: '20px',
  marginBottom: '20px',
}))

export const CardHead = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '16px',
}))

export const CardHeadRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}))

export const IconBadge = styled('div')(() => ({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  background: '#E5F3FF',
  color: theme.talentinoBlue,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}))

export const NumberBadge = styled('div')(() => ({
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  background: theme.brandColorOrange,
  color: theme.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '13px',
  fontFamily: 'PoppinsMedium',
  flexShrink: 0,
}))

export const Divider = styled('div')(({ spaced }) => ({
  height: '1px',
  background: '#EEF2F7',
  margin: spaced ? '16px -20px' : '0 -20px 16px',
}))

export const InfoBox = styled('div')(() => ({
  display: 'flex',
  gap: '10px',
  background: '#EEF6FF',
  border: '1px solid #D6E4FF',
  padding: '14px 16px',
  borderRadius: '10px',
  marginBottom: '20px',
}))

export const InfoIcon = styled(Info)(() => ({
  flexShrink: 0,
  marginTop: '1px',
}))

export const Grid = styled('div')(({ columns = 2 }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
  gap: '14px 16px',
  '@media (max-width: 520px)': {
    gridTemplateColumns: '1fr',
  },
}))

export const ErrorText = styled('span')(() => ({
  color: theme.danger,
  fontSize: '11px',
  marginTop: '4px',
}))

export const RemoveButton = styled('button')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  background: 'transparent',
  border: 'none',
  color: theme.talentinoSecondaryGray,
  fontSize: '13px',
  padding: 0,
  '&:hover': { color: theme.danger },
}))

export const AddButton = styled('button')(() => ({
  width: '100%',
  border: `1px dashed ${theme.brandColorOrange}`,
  background: theme.white,
  color: theme.brandColorOrange,
  borderRadius: '10px',
  padding: '12px',
  fontSize: '12px',
  fontFamily: 'PoppinsMedium',
  marginBottom: '20px',
  '&:hover': { background: theme.talentinoLightBlueBackground },
}))

export const ConsentRow = styled('label')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  fontSize: '13px',
  color: theme.talentinoTextGray,
  marginBottom: '20px',
  cursor: 'pointer',
}))
